module.exports = __webpack_public_path__ + "media/images/new_home/mobile-meal-bg-27cdfd342e18276461644cec7fe95655.png";